import React, { useEffect, useRef } from "react";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import MobileSidebar from "./MobileSidebar";
import logoLight from "../../assets/images/logoLight.svg";
import CartNavLink from "../../components/cart/CartNavLink";
import DropdownMenu from "./DropdownMenu";
import AppRoutes from "../../routes/AppRoutes";
import { NAV_LINKS } from "../../constants/navigation";
import { scrollToTop } from "../../utils/scroll";
import { isRtlLanguage } from "../../utils/i18n";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";

function NavBar(props) {
  const { t, i18n } = useTranslation();
  const ref = useRef();
  const isRtl = isRtlLanguage(i18n.language);

  const toggleMenu = () => {
    if (window.innerWidth >= 1024) return;
    props.setTogol2(!props.togol2);
  };

  const closeMenu = () => {
    props.setTogol2(false);
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 1024) {
        closeMenu();
      }
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div
      ref={ref}
      id="nav"
      className={isRtl ? "arFont overflow-x-clip" : "enFont overflow-x-clip"}
      dir={isRtl ? "rtl" : "ltr"}
    >
      <button
        type="button"
        id="nav2"
        onClick={closeMenu}
        className={`mobile-nav-overlay lg:hidden ${props.togol2 ? "visible" : "hidden"}`}
        aria-hidden={!props.togol2}
        aria-label={t("Close")}
      />
      <MobileSidebar
        isOpen={props.togol2}
        onToggle={props.setTogol2}
        onLanguageChange={closeMenu}
      />
      <nav id="navBarS" className="h-0">
        <div className="relative z-10 mx-auto flex h-[10vh] w-full max-w-7xl items-center justify-between px-4 sm:h-[13vh] sm:px-6 lg:w-[92%] xl:w-[85%]">
          <div className="shrink-0">
            <img
              src={logoLight}
              alt="CAF Sports"
              className="w-[80px] sm:w-[100px] lg:w-[120px]"
            />
          </div>
          <div
            className={`hidden items-center gap-4 text-sm font-semibold lg:flex xl:gap-6 xl:text-base ${
              isRtl ? "flex-row-reverse" : ""
            }`}
          >
            <CartNavLink />
            <DropdownMenu onLanguageChange={closeMenu} />
            <ul className="flex gap-4 xl:gap-5">
              {NAV_LINKS.map(({ to, labelKey }) => (
                <li key={to} className="navlink text-[#ffffff]">
                  <NavLink
                    onClick={scrollToTop}
                    className={({ isActive }) =>
                      `navlink0 whitespace-nowrap${isActive ? " active" : ""}`
                    }
                    to={to}
                  >
                    {t(labelKey)}
                  </NavLink>
                </li>
              ))}
            </ul>
          </div>
          <div className="flex shrink-0 items-center gap-3 lg:hidden">
            <CartNavLink className="caf-cart-nav--mobile" />
            <button
              type="button"
              onClick={toggleMenu}
              className="inline-flex h-10 w-10 items-center justify-center rounded-full border border-white/25 bg-black/15 text-white transition-colors hover:bg-black/30"
              aria-label="Menu"
              aria-expanded={props.togol2}
            >
              <FontAwesomeIcon
                className="text-[18px] sm:text-[20px]"
                icon={faBars}
              />
            </button>
            <DropdownMenu onLanguageChange={closeMenu} />
          </div>
        </div>
      </nav>
      <AppRoutes />
    </div>
  );
}

export default NavBar;
